import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MODE_ADD, MODE_EDIT, MODE_UNKNOWN, DEFAULT_IP } from "app/utils/constant";
import { cmnAssignFromBase, cmnSetValByPath } from "app/utils/utils";
import axios from "axios";

const defaultBasicInfoFormMap = {
    "account_name": { type: "input", val: "", label: "membername" },
    "account_birth": { type: "datepicker", val: "", label: "dobb" },
    "account_gender": {
        type: "select", val: "m", label: "gender",
        options: [{ label: "mMale", value: "m" }, { label: "mFemale", value: "f" }]
    },
    "f_age": { type: "input", val: "", label: "ageb", ignore: true },
    "account_phone": { type: "input", val: "", label: "mobile" },
    "member_id": { type: "input", val: "", label: "memberid" },
    "account_email": { type: "input", val: "", label: "email" },
    "card_ref": { type: "input", val: "", label: "mCardRef" },
    "lang": {
        type: "select", val: "zh", label: "preferedlang",
        options: [{ label: "mChinese", value: "zh" }, { label: "mEnglish", value: "en" }]
    },
    "account_address": { type: "input", val: "", label: "mAddress" },
    "account_avatar": { type: "other", val: "", label: "" }
};

const initialVolumnteer = {
    "account_id": "",
    "is_volunteer": false,
    "volunteer_setting": {
        "area": {
            "education": false,
            "handcraft": false,
            "visit": false,
            "community": false,
            "environmental": false
        },
        "time_of_date": {
            "afternoon": false,
            "evening": false,
            "morning": false
        },
        "days_of_the week": {
            "sunday": false,
            "saturday": false,
            "tuesday": false,
            "wednesday": false,
            "thursday": false,
            "friday": false,
            "monday": false
        },
        "promotion": {
            "post": false,
            "sms": false,
            "email": false
        }
    }
};

const initialInstructor = {
    "instructor_qualification": {
        "en": "",
        "zh": ""
    },
    "instructor_avatar": "",
    "instructor_bio": {
        "en": "",
        "zh": ""
    },
    "account_id": "",
    "is_instructor": false
};

const initialCaregiver = {
    "is_appointed_caregiver": false
};

const initialMembership = {
    "account_level": "free",
    "account_identity": "",
    "account_status": "",
    "account_centre": {
        "zh": "",
        "en": ""
    },
    "tags": [],
    // "is_caregiver": false
};

const initalMemberSurveyListItem = {
    "survey_id": "",
    "survey_content": {
        "zh": "",
        "en": ""
    },
    "survey_score": 0
};

const initialOtherBasicInfo = {
    "is_lock": false
};

const initialState = {
    memberEditMode: MODE_UNKNOWN,
    memberEditData: {},
    basicInfoFormMap: defaultBasicInfoFormMap,
    interestList: [],
    mobileList: [],
    engageInfos: {
        processing: [],
        completed: [],
        applied: [],
        processingCount: 0,
        completedCount: 0,
        appliedCount: 0
    },
    engageCounts: {
        "In-Progress": 0,
        "Completed": 0,
        "Application Status": 0
    },
    editInterests: [],
    editVolumnteer: initialVolumnteer,
    editInstructor: initialInstructor,
    editCaregiver: initialCaregiver,
    editMembership: initialMembership,
    editSurvey: [],
    editOtherBasicInfo: initialOtherBasicInfo,
    memberInfoUpdateTS: -1,
};

export const searchMembersByPage = (page, data, callback) => async (dispatch) => {
    let cat = data.cat;
    let keyword = data.keyword;

    let sendData = {};
    let key = "";
    switch (cat) {
        case "Name":
            key = "account_name";
            break;
        case "Email":
            key = "account_email";
            break;
        case "Member ID":
            key = "member_id";
            break;
        case "Mobile":
            key = "account_phone";
            break;
        case "Card Ref":
            key = "card_ref";
            break;
        case "Account ID":
            key = "account_id";
            break;
        case "MemberShip Level":
            key = "account_level";
            break;
    }

    sendData[key] = keyword;
    const thunkResult = await dispatch(searchMembersByPageReq({ page: page, data: sendData }));

    commonHandleError(thunkResult.payload, callback);
};

export const uploadAvatarImage = (accountId, file, callback) => async (dispatch) => {
    const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/getuploadfileurl",
        {
            "usage": "avatar",
            "file": file.name,
            "account_id": accountId
        });

    let data = postRes.data;

    if (1 == data?.code) {
        let putUrl = data.data.image_upload_url;
        let realImgUrl = data.data.image_url;
        let subName = file.name.substring(file.name.indexOf(".") + ".".length);

        let xhr = new XMLHttpRequest();
        xhr.open("PUT", putUrl, true);
        xhr.setRequestHeader("Content-Type", "image/" + subName);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    callback(realImgUrl, "");
                } else {
                    callback(null, "upload failed:,", xhr.status, xhr.responseText);
                }
            }
        };

        xhr.send(file);
    } else {
        if (!data) {
            callback(null, "upload failed: no data");
        }
        else {
            callback(null, "upload failed, code:" + data.code + " message:" + data.message_en);
        }
    }
};

export const getMemberDetail = (accountId, callback) => async (dispatch) => {
    let thunkResult;
    if (!accountId) {
        let action = createAction("mMemberReq/tknAware/getMemberDetail/fulfilled");
        let simulateResp = {
            "code": 1,
            "data": {}
        };

        thunkResult = await dispatch(action(simulateResp));
    } else {
        let sendData = {
            "account_id": accountId
        };

        thunkResult = await dispatch(getMemberDetailReq(sendData));
    }

    commonHandleError(thunkResult.payload, callback);
};


export const getMembersByPage = (page, callback) => async (dispatch) => {
    const thunkResult = await dispatch(getMembersByPageReq(page));
    commonHandleError(thunkResult.payload, callback);
}

export const getInterestList = () => async (dispatch) => {
    await dispatch(getInterestListReq());
};

export const getMobileList = (sendData) => async (dispatch) => {
    await dispatch(getMobileListReq(sendData));
};

export const deleteMobile = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(deleteMobileReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const createMember = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(createMemberReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const updateMember = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(updateMemberReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const deleteMember = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(deleteMemberReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const updateInterests = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(updateInterestsReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const updatePwd = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(updatePwdReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const updateInstructor = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(updateInstructorReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const updateVolumnteer = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(updateVolumnteerReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const getSurvey = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(getSurveyReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const getCampaignEngageList = (sendData) => async (dispatch) => {
    await dispatch(getCampaignEngageListReq(sendData));
};

export const updateMembership = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(updateMembershipReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const getMemberHealthRecordList = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(getMemberHealthRecordListReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

const getMembersByPageReq = createAsyncThunk("mMemberReq/tknAware/getMembersByPage", async (page) => {
    let res = await axios.get(DEFAULT_IP + "/webapp/memportal/getmemberlistv2?page=" + page);
    return res.data;
});

const searchMembersByPageReq = createAsyncThunk("mMemberReq/tknAware/searchMembersByPage", async (obj) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/searchmemberv2?page=" + obj.page, obj.data);
    return res.data;
});

const createMemberReq = createAsyncThunk("mMemberReq/tknAware/createMember", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/addmemberbasic", data);
    // const res = await axios.post("http://localhost:3007/createMember", data);
    return res.data;
});

const updateMemberReq = createAsyncThunk("mMemberReq/tknAware/updateMember", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/updatememberbasic", data);
    // const res = await axios.post("http://localhost:3007/updateMember", data);
    return res.data;
});

const getMemberDetailReq = createAsyncThunk("mMemberReq/tknAware/getMemberDetail", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/getmemberdetail", data);
    return res.data;
});

const getMemberHealthRecordListReq = createAsyncThunk("mMemberReq/tknAware/getMemberHealthRecordList", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/getmemberhealthrecordlist", data);
    return res.data;
});

const getInterestListReq = createAsyncThunk("mMemberReq/tknAware/getInterestList", async () => {
    let res = await axios.get(DEFAULT_IP + "/webapp/memportal/getinterestlist");
    return res.data;
});

const getMobileListReq = createAsyncThunk("mMemberReq/tknAware/getMobileList", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/getmembermobilelist", data);
    return res.data;
});

const deleteMobileReq = createAsyncThunk("mMemberReq/tknAware/deleteMobile", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/deletemembermobile", data);
    // const res = await axios.post("http://localhost:3007/deletemembermobile", data);
    return res.data;
});


const updateInterestsReq = createAsyncThunk("mMemberReq/tknAware/updateInterests", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/updatememberinterest", data);
    return res.data;
});

const deleteMemberReq = createAsyncThunk("mMemberReq/tknAware/deleteMember", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/deleteaccount", data);
    return res.data;
});

const updateInstructorReq = createAsyncThunk("mMemberReq/tknAware/updateInstructor", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/updatememberinstructor", data);
    return res.data;
});

const updatePwdReq = createAsyncThunk("mMemberReq/tknAware/updatePwd", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/updatememberpassword", data);
    return res.data;
});

const updateVolumnteerReq = createAsyncThunk("mMemberReq/tknAware/updateVolumnteer", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/updatemembervolunteer", data);
    return res.data;
});

const getSurveyReq = createAsyncThunk("mMemberReq/tknAware/getSurvey", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/getcampaignsurveyresult", data);
    // let res = await axios.post("http://localhost:3007/getmemberSurvey", data);
    return res.data;
});

const getCampaignEngageListReq = createAsyncThunk("mMemberReq/tknAware/getCampaignEngageList", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/getaccountattendcampaign", data);
    return res.data;
});

const updateMembershipReq = createAsyncThunk("mMemberReq/tknAware/updateMembership", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/updatemembership", data);
    return res.data;
});


const commonHandleError = (data, callback) => {
    if (callback) {
        let baseErrorMsgObj = {
            message: "系統發生問題, 請稍後再試",
            message_en: "An unexpected error occurred. Please try again."
        }

        if (1 == data?.code) {
            callback(true, data);
        } else {
            callback(false, (data) ? (data) : (baseErrorMsgObj))
        }
    }
};

const calculateAge = (dob) => {
    if (!dob) return "";

    const birthDate = new Date(dob);
    const today = new Date();

    let years = today.getFullYear() - birthDate.getFullYear();

    const isBeforeBirthdayThisYear =
        today.getMonth() < birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate());

    if (isBeforeBirthdayThisYear) {
        years -= 1;
    }

    return (`${years} ${years !== 1 ? '' : ''}`);
};

const sortDate = (a, b) => {
    const getDate = (entry) => {
        if (!entry.create_date) return 0;
        if (Array.isArray(entry.create_date)) {
            return entry.create_date[0] || 0;
        }
        return entry.create_date;
    };

    const dateA = getDate(a);
    const dateB = getDate(b);
    return dateB - dateA;
};

const rdxMemberSlice = createSlice({
    initialState,
    name: "rdxMember",
    extraReducers: (builder) => {
        builder
            .addCase(getMembersByPageReq.fulfilled, (state, actions) => { })
            .addCase(searchMembersByPageReq.fulfilled, (state, actions) => { })
            .addCase(getMemberDetailReq.fulfilled, (state, actions) => {
                let data = actions.payload;
                if (data.code === 1) {
                    let origMemberData = data.data;

                    //TODO days_of_the' 'week 錯別字修正後移除
                    if (origMemberData.volunteer_setting && origMemberData.volunteer_setting["days_of_the week"]) {
                        origMemberData.volunteer_setting["days_of_the_week"] = origMemberData.volunteer_setting["days_of_the week"];
                        delete origMemberData.volunteer_setting["days_of_the week"];
                    }

                    if (!origMemberData.is_lock) {
                        origMemberData.is_lock = false;
                    }

                    try {
                        if (origMemberData.account_birth) {
                            origMemberData.account_birth = origMemberData.account_birth.substring(0, origMemberData.account_birth.lastIndexOf("-")) + "-01";
                        }
                    } catch (err) { }

                    state.memberEditData = origMemberData;
                    if (!data.data.account_id) {
                        state.memberEditMode = MODE_ADD;
                    } else {
                        state.memberEditMode = MODE_EDIT;
                    }
                }
            })
            .addCase(getInterestListReq.fulfilled, (state, actions) => {
                let data = actions.payload;
                if (data.code === 1) {
                    state.interestList = data.data;
                }
            })

            .addCase(getMobileListReq.fulfilled, (state, actions) => {
                let data = actions.payload;
                if (data.code === 1) {
                    state.mobileList = data.data;
                }
            })
            .addCase(getSurveyReq.fulfilled, (state, actions) => {
                let data = actions.payload;
                if (data.code === 1 && data.data) {
                    state.editSurvey = data.data;
                }
            })
            .addCase(getCampaignEngageListReq.fulfilled, (state, actions) => {
                let data = actions.payload;
                if (data.code === 1 && data.data) {
                    state.engageInfos.processing =
                        (data.data.processing) ? (data.data.processing) : [];

                    state.engageInfos.completed =
                        (data.data.completed) ? (data.data.completed) : [];

                    state.engageInfos.applied =
                        (data.data.applied) ? (data.data.applied) : [];

                    state.engageCounts["In-Progress"] =
                        (data.data.processing) ? data.data.processing.length : 0;

                    state.engageCounts["Completed"] =
                        (data.data.completed) ? data.data.completed.length : 0;

                    state.engageCounts["Application Status"] =
                        (data.data.applied) ? data.data.applied.length : 0;
                }
            });
    },
    reducers: {
        setCreateLoading(state, actions) {
            let { loading } = actions.payload;
            if (loading) {
                state.memberEditMode = MODE_UNKNOWN;
            } else {
                state.memberEditMode = MODE_ADD;
            }
        },
        tagMemberBasicInfoUpdate(state, actions) {
            state.memberInfoUpdateTS = new Date().getTime()
        },
        setEditMemberData(state, actions) {
            let nextEditMember = { ...actions.payload };
            state.memberEditData = nextEditMember;

            // console.log(nextEditMember);
            for (const key in state.basicInfoFormMap) {
                state.basicInfoFormMap[key].val = nextEditMember[key] || state.basicInfoFormMap[key].val;
            }

            let birth = nextEditMember["account_birth"];
            if (birth) {
                state.basicInfoFormMap["f_age"].val = calculateAge(birth);
            }

            let data = { "is_lock": nextEditMember.is_lock }
            let obj = cmnAssignFromBase(initialOtherBasicInfo, data);
            state["editOtherBasicInfo"] = obj;
        },
        clearEditMember(state) {
            state.memberEditMode = MODE_UNKNOWN;
            state.memberEditData = {};
            state.basicInfoFormMap = defaultBasicInfoFormMap;
        },
        resetAllMemberPageData(state) {
            state = initialState;
        },
        setMemberPageFormData(state, actions) {
            let { data, projection } = actions.payload;
            state[projection][data.key].val = data.val;
        },
        setPageFormToMemberData(state, actions) {
            let existFormMap = actions.payload.formMap;

            for (const key in existFormMap) {
                let obj = existFormMap[key];
                if (!obj.ignore) {
                    state.memberEditData[key] = obj.val;
                }
            }
        },
        initSimpleData(state, actions) {
            let { data, projection, type } = actions.payload;

            if ("list" == type) {
                let resultData = (data) ? data : [];
                state[projection] = resultData;
            } else if ("obj" == type) {
                let base = {};
                switch (projection) {
                    case "editVolumnteer": base = initialVolumnteer; break;
                    case "editInstructor": base = initialInstructor; break;
                    case "editMembership": base = initialMembership; break;
                    case "editCaregiver": base = initialCaregiver; break;
                    case "editSurvey": base = []; break;
                }

                let obj = cmnAssignFromBase(base, data);
                state[projection] = obj;
            }
        },
        setSimpleData(state, actions) {
            let { data, projection, path } = actions.payload;

            if (Array.isArray(data) && !path) {
                state[projection] = data;
            } else {
                let formatPath;
                if (path.indexOf(projection) == 0) {
                    let headStr = projection + ".";
                    formatPath = path.substring(headStr.length);
                } else {
                    formatPath = path;
                }
                cmnSetValByPath(state[projection], formatPath, data);
            }
        },
        setSimpleDataToMemberData(state, actions) {
            let { data, projection, base } = actions.payload;

            if (Array.isArray(data)) {
                // console.log("list update:", projection, data);
                state.memberEditData[projection] = data;
            } else {
                let obj = Object.assign({}, base, data);
                if ("self" == projection) {
                    // console.log("self update:", projection, obj);
                    state.memberEditData = obj;
                } else {
                    // console.log("partial update:", projection, obj);
                    state.memberEditData[projection] = obj;
                }
            }
        }
    }
});

export const {
    setCreateLoading, tagMemberBasicInfoUpdate,
    setEditMemberData, clearEditMember, resetAllMemberPageData,
    setMemberPageFormData, setPageFormToMemberData,
    initSimpleData, setSimpleData, setSimpleDataToMemberData } = rdxMemberSlice.actions;

export const rdxMemberReducer = rdxMemberSlice.reducer;